import actionTypes from "constants/configs";
import { Action, ActionFunctionAny, createActions } from "redux-actions";
import { loadConfigsData } from "sources/configs";

const { SET_CONFIGS } = actionTypes;

const actions = createActions(SET_CONFIGS);

const loadConfigs = () => (dispatch: ActionFunctionAny<Action<Object>>) =>
    loadConfigsData().then((data) => dispatch(actions.setConfigs(data)));

export default { ...actions, loadConfigs };
